import './polyfills';
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { preloadLogo } from "@/hooks/useImageCache";
import atlasLogo from "@/assets/atlas-logo.png";

// Preload logo immediately on app start
preloadLogo(atlasLogo);

createRoot(document.getElementById("root")!).render(<App />);
